/** Presentation only: domain review contracts still determine permitted actions. */
export function reviewReason(reason:string):string {
  const messages:Record<string,string>={
    recognition_structure_unresolved:'表格关联区域有文字尚未核对，暂不能确认完整的数据结构。',
    source_rows_unavailable:'尚未可靠区分表头、数据行和说明文字，不能直接进行完整统计。',
    source_column_alignment:'同一张表的不同部分列名或列顺序未对齐，需要核对是否为续表。',
    meaning_not_explicit:'该字段的含义、类型或单位尚不明确，请按下面的问题补充说明。',
    recognition_unresolved:'相关原文尚未识别清楚，请对照标记区域核对文字。'
  };
  return messages[reason]??(/^[a-z][a-z0-9_]+$/.test(reason??'')?'此处需要人工确认，请查看具体问题和原件；技术原因可在“技术详情”中查看。':reason);
}
export function reviewGuidance(item:any):string[] {
  const detail=item.evidence?.detail??{};
  if(item.reason!=='recognition_structure_unresolved')return [];
  return [detail.impact??'这张表暂不能用于完整统计，原文仍保留供检索。',
    detail.next_step??'请打开原件核对相关区域，并在“识别复核”事项中确认或修正文字后重新构建。旧事项可能未记录具体疑点，请查看该文件的识别复核事项。当前事项只能保留原文，不能直接修改行列；若没有对应复核事项，请提供更清晰的材料或联系管理员排查。'];
}

export function fieldConfirmationError(value:{meaning:string;unit:string;type:string;additive:boolean}):string|null {
  if(!value.meaning.trim())return '请说明这一列实际表示什么，例如单笔数值还是某一时点的余额。';
  if(value.additive&&value.type!=='decimal')return '允许求和的字段必须选择“数值”类型；标识符或日期不应设置为求和。';
  if(value.additive&&!value.unit.trim())return '请先填写已确认的计量单位再允许求和。若无法确认单位，请选择“暂无法确认，保留疑问”；若该字段本来不应求和，请取消“允许同单位明细求和”。';
  return null;
}
